(function () {
  MapController.$inject = ["$log", "$timeout", "$scope", "NgMap", "Orders", "Pharmacy", "GOOGLE_MAPS_KEY"];
  angular.module('pims').controller('MapController', MapController);
  /* @ngInject */

  function MapController($log, $timeout, $scope, NgMap, Orders, Pharmacy, GOOGLE_MAPS_KEY) {
    const self = this;

    if (!$scope.ngDialogData) {
      throw 'Please provide a data object with a title.';
    }

    self.googleMapsUrl = `https://maps.google.com/maps/api/js?key=${GOOGLE_MAPS_KEY}`;
    self.pharmacy = $scope.ngDialogData.pharmacy;
    self.title = $scope.ngDialogData.title;
    self.zoom = 10;
    self.markers = [];

    self.onMarkerSelect = function (marker) {
      $scope.closeThisDialog(marker);
    };

    self.geocode = function (address) {
      Pharmacy.geocode(address).then(results => {
        const data = results.data;
        $log.log(data);

        if (data.status === 'OK') {
          const geocode = data.results[0];

          _getPharmacies(geocode.geometry.location);
        }
      }).catch(err => {
        $log.log(err);
      });
    };

    self.geocode(self.pharmacy.zip);
    /* Private */

    function _createMarkers(locations) {
      self.markers = _.map(locations, location => {
        location.position = [location.lat, location.lng];
        return location;
      });
      NgMap.getMap().then(map => {
        self.map = map;

        _fitBounds();
      });
    }

    function _fitBounds() {
      const bounds = new window.google.maps.LatLngBounds();
      self.markers.forEach(marker => {
        const latlng = new window.google.maps.LatLng(marker.position[0], marker.position[1]);
        bounds.extend(latlng);
      });
      self.map.setCenter(bounds.getCenter());
      self.map.fitBounds(bounds);
    }

    function _getPharmacies(coords) {
      self.center = _.toArray(coords);
      Pharmacy.search(coords).then(results => {
        $log.log('Pharmacies: ', results.data);
        self.initialized = true;

        _createMarkers(results.data);
      });
    }
  }
})();